import { render, staticRenderFns } from "./campos-obrigatorios.vue?vue&type=template&id=18d62da2&"
import script from "./campos-obrigatorios.vue?vue&type=script&lang=js&"
export * from "./campos-obrigatorios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18d62da2')) {
      api.createRecord('18d62da2', component.options)
    } else {
      api.reload('18d62da2', component.options)
    }
    module.hot.accept("./campos-obrigatorios.vue?vue&type=template&id=18d62da2&", function () {
      api.rerender('18d62da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/campos-obrigatorios.vue"
export default component.exports